// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "高等数学（一）",
      "tec": "毛显",
      "week": "6-17周",
      "add": "教学楼D座516信息AISEC"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "程序设计基础",
      "tec": "杨政",
      "week": "6-17周",
      "add": "实训楼F座301信息"
    },
    {
      "sub": "高等数学（一）",
      "tec": "毛显",
      "week": "6-17周",
      "add": "教学楼D座516信息AISEC"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "刘娜",
        "week": "6-17周",
        "add": "实训楼E座310"
      },
      {
        "sub": "26计理2-1",
        "tec": "王国志",
        "week": "6-17周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "26计理1-2",
        "tec": "徐亮",
        "week": "6-17周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "26计理1-1",
        "tec": "曹艳春",
        "week": "6-17周",
        "add": "实训楼E座412语音室"
      }
    ],
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[07-08节]）"
    },
    0
  ],
  "3": [
    {
      "sub": "明辨性思维",
      "tec": "王淑慧",
      "week": "6-13周",
      "add": "教学楼D座422信息AISEC"
    },
    {
      "sub": "计算机科学导论",
      "tec": "曾祥萍",
      "week": "6-16周",
      "add": "实训楼F座303信息"
    },
    0,
    0,
    {
      "sub": "形势与政策",
      "tec": "张梦琪",
      "week": "6,8-10周",
      "add": "教学楼C座113教务"
    }
  ],
  "4": [
    [
      {
        "sub": "大学英语（一）",
        "tec": "刘娜",
        "week": "6-17周",
        "add": "教学楼D座226经管"
      },
      {
        "sub": "26计理2-1",
        "tec": "曹艳春",
        "week": "6-17周",
        "add": "教学楼A座122信息"
      },
      {
        "sub": "26计理2-2",
        "tec": "徐亮",
        "week": "6-17周",
        "add": "教学楼A座125信息"
      },
      {
        "sub": "26计理1-1",
        "tec": "王国志",
        "week": "6-17周",
        "add": "教学楼A座126信息"
      }
    ],
    {
      "sub": "心理健康与调适",
      "tec": "王淑慧",
      "week": "6-15周",
      "add": "教学楼D座515信息AISEC"
    },
    {
      "sub": "程序设计基础",
      "tec": "杨政",
      "week": "6-17周",
      "add": "实训楼F座303信息"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "高等数学（一）",
      "tec": "毛显",
      "week": "6-17周",
      "add": "教学楼D座516信息AISEC"
    },
    {
      "sub": "计算机科学导论",
      "tec": "曾祥萍",
      "week": "6-16单周",
      "add": "教学楼C座403管理"
    },
    {
      "sub": "军事理论",
      "tec": "于修理",
      "week": "8-16周",
      "add": "教学楼C座215教务"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
